// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"homepage-banners_uk-open__53sYa","grecaptcha-badge":"homepage-banners_grecaptcha-badge__SuZg8","root":"homepage-banners_root__4FE4e","slider":"homepage-banners_slider__M7XbH","banner":"homepage-banners_banner__qkCGt","dots":"homepage-banners_dots__Z6s20","dot":"homepage-banners_dot__XaW7t","activeDot":"homepage-banners_activeDot__oKS0V"};
    if(module.hot) {
      // 1793877037497
      var cssReload = require("!../../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  